/**
 * ModelStore - Abstract storage for model metadata
 * Step 4: Provides status tracking for model downloads/loading
 *
 * NOTE: This does NOT store model weights. WebLLM handles that internally.
 * This is advisory metadata to improve UX (warm start detection, error tracking).
 */
// === Helper Functions ===
/**
 * Create a new store record with current timestamp
 */
export function createStoreRecord(modelId, engine, status, manifestVersion, lastError) {
    return {
        modelId,
        engine,
        status,
        updatedAt: Date.now(),
        manifestVersion,
        lastError,
    };
}
//# sourceMappingURL=ModelStore.js.map